var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-icon",
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 32,
    height: 32,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.667 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "babfacaf-e360-4afd-b18a-08ba18840f21",
    cx: 3.273,
    cy: 3.273,
    r: 3.273,
    transform: "translate(6.061 4.727)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2583718c-9755-4943-94f5-46d6c8b8efb9",
    "data-name": "2583718c-9755-4943-94f5-46d6c8b8efb9",
    d: "M21.164,16.364a1.8,1.8,0,0,0,.36,1.985l.065.066A2.183,2.183,0,1,1,18.5,21.5l-.066-.066a1.814,1.814,0,0,0-3.076,1.288v.185a2.182,2.182,0,0,1-4.364,0v-.1a1.8,1.8,0,0,0-1.178-1.647,1.8,1.8,0,0,0-1.985.36l-.066.065A2.183,2.183,0,1,1,4.68,18.5l.065-.066A1.814,1.814,0,0,0,3.458,15.36H3.273a2.182,2.182,0,1,1,0-4.364h.1A1.8,1.8,0,0,0,5.018,9.818a1.8,1.8,0,0,0-.36-1.985l-.065-.066A2.183,2.183,0,1,1,7.68,4.68l.065.065a1.8,1.8,0,0,0,1.986.36h.087a1.8,1.8,0,0,0,1.091-1.647V3.273a2.182,2.182,0,1,1,4.364,0v.1a1.814,1.814,0,0,0,3.076,1.287l.066-.065A2.183,2.183,0,1,1,21.5,7.68l-.066.065a1.8,1.8,0,0,0-.36,1.986v.087a1.8,1.8,0,0,0,1.648,1.091h.185a2.182,2.182,0,0,1,0,4.364h-.1A1.8,1.8,0,0,0,21.164,16.364Z",
    transform: "translate(-3.758 -5.091)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.204f94b8626e551875cbc6f370cda513.svg";
export { ForwardRef as ReactComponent };